import { render, staticRenderFns } from "./LensMetricTable.vue?vue&type=template&id=c07d52e4&scoped=true"
import script from "./LensMetricTable.vue?vue&type=script&lang=js"
export * from "./LensMetricTable.vue?vue&type=script&lang=js"
import style0 from "./LensMetricTable.vue?vue&type=style&index=0&id=c07d52e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d52e4",
  null
  
)

export default component.exports